var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.devisForm
        ? _c("cm-attachments-devis-form", {
            attrs: { devisFormData: _vm.devisFormData },
            on: {
              close: function ($event) {
                _vm.devisForm = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.changePasswordPopup
        ? _c("cm-change-password-popup", {
            staticClass: "z-10080",
            attrs: { data: _vm.changePasswordPopupData },
            on: {
              close: function ($event) {
                _vm.changePasswordPopup = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.paymentAxepta
        ? _c("cm-payment-axepta", {
            attrs: { paymentDetails: _vm.paymentDetails },
            on: {
              close: function ($event) {
                _vm.paymentAxepta = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.bankAccountQRCode
        ? _c("bank-account-qr-code", {
            attrs: { accountId: _vm.accountId },
            on: {
              close: function ($event) {
                _vm.bankAccountQRCode = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.choiceBankAccount
        ? _c("choice-bank-account", {
            attrs: { data: _vm.choiceBankAccountData },
            on: {
              close: function ($event) {
                _vm.choiceBankAccount = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.choicePaymentCancel
        ? _c("choice-payment-cancel", {
            attrs: { data: _vm.choicePaymentCancelData },
            on: {
              close: function ($event) {
                _vm.choicePaymentCancel = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.choicePaymentInstalment
        ? _c("choice-payment-instalment", {
            attrs: { data: _vm.choicePaymentInstalmentData },
            on: {
              close: function ($event) {
                _vm.choicePaymentInstalment = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.choicePaymentRefuse
        ? _c("choice-payment-refuse", {
            attrs: { data: _vm.choicePaymentRefuseData },
            on: {
              close: function ($event) {
                _vm.choicePaymentRefuse = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.choiceRejectPayment
        ? _c("choice-reject-payment", {
            attrs: { data: _vm.choiceRejectPaymentData },
            on: {
              close: function ($event) {
                _vm.choiceRejectPayment = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.scannerQRCode
        ? _c("scanner-qr-code", {
            attrs: { content: _vm.scannerQRCodeContent },
            on: {
              close: function ($event) {
                _vm.scannerQRCode = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("cm-service-popups"),
      _vm._v(" "),
      _c("cm-service-switcher-popup", { attrs: { closeButton: true } }),
      _vm._v(" "),
      _c("cm-switch-profile", { attrs: { closeButton: true } }),
      _vm._v(" "),
      _c("cm-user-reset-password", { attrs: { closeButton: true } }),
      _vm._v(" "),
      _vm.documentViewer
        ? _c("document-viewer", {
            attrs: { data: _vm.documentViewerData },
            on: {
              close: function ($event) {
                _vm.documentViewer = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.importFile
        ? _c("import-file", {
            attrs: { importFileData: _vm.importFileData },
            on: {
              close: function ($event) {
                _vm.importFile = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.xmlDetails
        ? _c("xml-details", {
            attrs: { xmlDetailsData: _vm.xmlDetailsData },
            on: {
              close: function ($event) {
                _vm.xmlDetails = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }